// extracted by mini-css-extract-plugin
export default {"loader":"Preloader_loader__TKWuo","svg":"Preloader_svg__Gl0T+","rotate360":"Preloader_rotate360__Nwij8","preloader":"Preloader_preloader__Tw4bb"};